import { CollectionSummary } from '@qkindex/contracts';
import { collectionCapabilities } from '../collection/collectionCapabilities';
import { scopeRecord } from '../collection/multiCollectionIdentity';
import { useSharedCollectionInventory } from '../collection/useSharedCollectionInventory';

/** Reuse browse pages and request only missing destination-location pages. */
export function useMoveLocations(
  userId: string,
  collections: CollectionSummary[],
  enabled: boolean,
) {
  const candidates = enabled
    ? collections.filter(
        (entry) =>
          collectionCapabilities('collection-only', entry.role, entry.lifecycle)
            .canEditInventory,
      )
    : [];
  const inventory = useSharedCollectionInventory(
    userId,
    candidates.map((entry) => entry.collectionId),
    ['locations'],
  );
  const writable = inventory.entries.filter(
    (entry) =>
      entry.summary &&
      collectionCapabilities(
        'collection-only',
        entry.summary.role,
        entry.summary.lifecycle,
      ).canEditInventory,
  );
  const ready = writable.filter(
    (entry) => entry.status === 'ready' && !entry.locations.failed,
  );
  const failed = inventory.entries.some(
    (entry) =>
      entry.status === 'error' ||
      entry.status === 'unavailable' ||
      entry.locations.failed,
  );
  const loading =
    inventory.entries.some((entry) => entry.status === 'loading') ||
    ready.some(
      (entry) =>
        !entry.locations.initialized ||
        Boolean(entry.locations.nextCursor) ||
        entry.locations.busy,
    );
  const locations = ready
    .filter(
      (entry) => entry.locations.initialized && !entry.locations.nextCursor,
    )
    .flatMap((entry) =>
      entry.locations.records.map((location) =>
        scopeRecord(location, entry.summary!),
      ),
    );
  // Reopening a picker reuses fresh pages. Explicit recovery retries failed data.
  return { locations, loading, failed, refresh: inventory.retry };
}
